/* Kniha 2 funnel: the pop-up, countdowns, one tap cross sell. */
(function () {
  /* bigger close button on the package summary (44 px tap target) */
  try { var css = document.createElement('style'); css.textContent = '.k2s-x{width:44px!important;height:44px!important;top:10px!important;right:10px!important}'; document.head.appendChild(css); } catch (e) {}
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function pad(n) { return ('0' + n).slice(-2); }

  /* countdowns (pop-up and home band) */
  [].forEach.call(document.querySelectorAll('[data-k2p-count]'), function (box) {
    var host = box.closest('[data-end]') || box;
    var end = Date.parse(box.getAttribute('data-end') || host.getAttribute('data-end') || '');
    if (!end) return;
    var d = box.querySelector('[data-d]'), h = box.querySelector('[data-h]'), m = box.querySelector('[data-m]');
    (function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      d.textContent = Math.floor(s / 86400); h.textContent = pad(Math.floor(s % 86400 / 3600)); m.textContent = pad(Math.floor(s % 3600 / 60));
      if (s) setTimeout(tick, 20000);
    })();
  });

  /* Book pre-order: dismiss once; automatic triggers cannot reopen it. */
  var pop = document.querySelector('[data-k2p]');
  if (pop && !pop.hasAttribute('data-k2p-bound')) {
    pop.setAttribute('data-k2p-bound', 'true');
    var tab = document.querySelector('[data-k2p-open]');
    var KEY = 'k2pop', DAYS = 3;
    var cookieSeen = document.cookie.match(/(?:^|; )k2pop=([0-9]+)/);
    var seen = Math.max(+store(KEY) || 0, cookieSeen ? +cookieSeen[1] : 0);
    var shown = false, autoShown = false, dismissed = false, last = null;
    var t = null, retry = null;
    function remember() {
      var now = Date.now();
      store(KEY, now);
      document.cookie = KEY + '=' + now + '; Max-Age=259200; Path=/; SameSite=Lax; Secure';
    }
    function cancelAutomatic() {
      clearTimeout(t); clearTimeout(retry);
      removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExit);
    }
    function busy() {
      if (document.querySelector('dialog[open]')) return true;
      var sel = '[data-k2s]:not([hidden]),[data-k2b]:not([hidden]),#shopify-pc__banner,#shopify-pc__prefs,.cookie-banner';
      return [].some.call(document.querySelectorAll(sel), function (el) {
        var st = getComputedStyle(el);
        return st.display !== 'none' && st.visibility !== 'hidden' && el.getClientRects().length > 0;
      });
    }
    function open(why) {
      var manual = why === 'tab';
      if (shown || (!manual && (dismissed || autoShown))) return;
      if (!manual && busy()) {
        clearTimeout(retry);
        retry = setTimeout(function () { open(why); }, 5000);
        return;
      }
      autoShown = true; cancelAutomatic();
      shown = true; last = document.activeElement;
      pop.hidden = false; if (tab) tab.hidden = true;
      remember();
      var b = pop.querySelector('.btn');
      if (b) b.focus({ preventScroll: true });
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'k2_popup_open', reason: why }); } catch (e) {}
    }
    function close() {
      dismissed = true; cancelAutomatic(); remember();
      pop.hidden = true; shown = false; if (tab) tab.hidden = false;
      if (last && last.focus && document.contains(last)) {
        try { last.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    function onScroll() {
      var h = document.documentElement;
      if ((h.scrollTop + innerHeight) / h.scrollHeight > 0.5) open('scroll');
    }
    function onExit(e) {
      if (!e.relatedTarget && e.clientY < 8) open('exit');
    }
    [].forEach.call(pop.querySelectorAll('[data-k2p-close],[data-k2p-go]'), function (b) { b.addEventListener('click', close); });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    if (tab) tab.addEventListener('click', function () { open('tab'); });
    if (Date.now() - seen > DAYS * 864e5) {
      t = setTimeout(function () { open('time'); }, 9000);
      addEventListener('scroll', onScroll, { passive: true });
      if (matchMedia('(hover: hover)').matches) document.addEventListener('mouseout', onExit);
    } else if (tab) { tab.hidden = false; }
  }

  /* The cart uses a native POST and follows Shopify's redirect. */
  var nativeCartForm = document.getElementById('k2-cross-cart');
  if (nativeCartForm) {
    nativeCartForm.addEventListener('submit', function () {
      var b = document.querySelector('[data-k2x-add][form="k2-cross-cart"]');
      if (!b) return;
      b.disabled = true;
      b.setAttribute('aria-busy', 'true');
      b.textContent = /^en/i.test(document.documentElement.lang) ? 'Adding…' : 'Pridávam…';
    });
  }

  /* one tap cross sell */
  [].forEach.call(document.querySelectorAll('[data-k2x-add]'), function (b) {
    b.addEventListener('click', function () {
      var card = b.closest('[data-k2x]');
      if (card.getAttribute('data-place') === 'cart') return;
      b.disabled = true; b.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-k2x-add'), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'add_to_cart', source: 'k2_cross_' + card.getAttribute('data-place') }); } catch (e) {}
          if (card.getAttribute('data-place') === 'cart') { location.reload(); return; }
          card.classList.add('done');
          var ok = document.createElement('p'); ok.className = 'k2x-ok'; ok.textContent = /^en/i.test(document.documentElement.lang) ? 'Added to your cart.' : 'Pridané do košíka.';
          card.querySelector('.k2x-t').appendChild(ok);
          var c = document.querySelector('.cart-btn .count');
          if (c) { c.textContent = (+c.textContent || 0) + 1; c.removeAttribute('data-zero'); }
        })
        .catch(function () { b.disabled = false; b.removeAttribute('aria-busy'); location.href = card.querySelector('.k2x-more').href; });
    });
  });
})();

